/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ReferencedComponent from "./ComponentReference/ReferencedComponent";

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Component which stores a array of colors. */
@cc._decorator.ccclass
export default class ColorPalletteComponent extends ReferencedComponent
{
    /** Color array. */
    @property({ type: [cc.Color], visible: true})
    private _colors: cc.Color[] = [];

    /**
     * Fetches a color at given index.
     * @param index Index number of color.
     * @returns [[cc.Color]] as index.
     */
    public GetColor(index: number): cc.Color
    {
        if (index < 0) { index = 0; }

        return this._colors[index % this._colors.length];
    }
}
